export default interface DistributionItemModel {
  id: number;
  itemId: number;
  quantity: number;
  warehouseId: number;
  warehouse: string;
  orderOos?: number;
  short: string;
}

export const deriveRawToDistributionItem = (raw) => {
  return {
    id: raw.id,
    itemId: raw.itemId,
    quantity: raw.quantity,
    warehouseId: raw.warehouseId,
    warehouse: raw.warehouse,
    ...(raw.orderOos !== null && { orderOos: raw.orderOos }),
    short: raw.short,
  };
};
